<template>
  <div
    class="modal fade"
    id="reasonRejectedListModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="reasonRejectedListModalLabel"
  >
    <div
      class="modal-dialog modal-lg"
      role="document"
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span
              aria-hidden="true"
            >&times;</span>
          </button>
          <h4
            class="modal-title"
            id="reasonRejectedListModalLabel"
          >
            {{ $t('string.reasonRejectionList') }}
          </h4>
        </div>
        <div class="modal-body">
          <template v-if="isLoading">
            <p class="text-center text-muted">
              {{ $t('string.isLoading') }}
            </p>
          </template>
          <template v-else>
            <table class="table table-hover table-striped table-bordered">
              <thead>
                <tr>
                  <th>{{ $t('string.rejectedBy') }}</th>
                  <th>{{ $t('string.rejectedAt') }}</th>
                  <th>{{ $t('string.reason') }}</th>
                </tr>
              </thead>
              <tbody>
                <template v-if="applicationStatuses.length">
                  <tr
                    v-for="(item, key) in applicationStatuses"
                    :key="key"
                  >
                    <td>{{ item.rejected_by.name || $t('string.na') }}</td>
                    <td>{{ $moment(item.created_at).format('DD/MM/YYYY hh:mm:ss A') }}</td>
                    <td>
                      <template v-if="item.borrow_rejection_items.length">
                        <ul>
                          <li
                            v-for="(rejection_item, index) in item.borrow_rejection_items"
                            :key="index"
                          >
                            {{ rejection_item.reason }}
                          </li>
                        </ul>
                      </template>
                      <template v-else>
                        {{ $t('string.na') }}
                      </template>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="3">
                      {{ $t('string.na') }}
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </template>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-default"
            data-dismiss="modal"
          >
            {{ $t('button.close') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ReasonRejectedListModal',
  data () {
    return {
      applicationStatuses: [],
      isLoading: false
    }
  },
  computed: {
    ...mapState({
      applicable_id: state => state.rejectApplicant.applicable_id
    })
  },
  watch: {
    applicable_id () {
      if (this.applicable_id) {
        this.getApplicationStatus()
      }
    }
  },
  methods: {
    getApplicationStatus () {
      this.isLoading = true
      this.$axios.post(this.$base_api + '/api/v4/backend/borrow/get-rejection-history-list', {
        borrow_id: this.applicable_id
      }).then(({ data }) => {
        if (data.data) {
          this.applicationStatuses = data.data
        }
      }).catch((error) => {
        this.onResponseError(error)
      }).finally(() => {
        this.isLoading = false
      })
    }
  },
  mounted () {
    if (this.applicable_id) {
      this.getApplicationStatus()
    }
  }
}
</script>

<style scoped>

</style>
